import LabRepository from "./LabRepository";

const resource = "/unit-of-measure";

export default {
  getAll(params) {
    return LabRepository.get(`${resource}?limit=all`, { params });
  }
};
